import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=442fbc01&scoped=true&"
import script from "./signUp.vue?vue&type=script&lang=js&"
export * from "./signUp.vue?vue&type=script&lang=js&"
import style0 from "./signUp.vue?vue&type=style&index=0&id=442fbc01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442fbc01",
  null
  
)

export default component.exports